const NAME = "ASSISTANCE_TOTEM";

export default NAME;
